var Flowcor = Flowcor || {};

Flowcor.Carousel = function() {
  var _carousel = '.carousel';
  
  var _init = function() {
    $(_carousel).carousel({
      interval: 2000,
      pause: "hover",
    })
  }

  /** PUBLIC API **/
  return {
    init : function() {return _init();}
  };

}();

$(function() {
  Flowcor.Carousel.init();
});

